export const changeToTitleCase = (str: string) => {
  const updatedStr = str.toLowerCase().split(" ")
  const titleCase = updatedStr.map(word => {
    const titleCase = word.charAt(0).toUpperCase() + word.slice(1)
    return titleCase
  })
  return titleCase.join(" ")
}
